import script from "./AppButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppButton.vue?vue&type=script&setup=true&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=26ea535e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ea535e"]])

export default __exports__